export default {
  'transactions.productTitle.OB': 'Open Browser',
  'transactions.productTitle.OBLite': 'Open Browser Lite',
  'transactions.productTitle.MP': 'Metax TV',
  'transactions.productTitle.OB1.0': 'Open Browser 1.0',
  'transactions.productTitle.DistributionOwn': '内容分发',
  'transactions.productTitle.AdSdk': 'Ad SDK',
  'transactions.productTitle.DistributionThirdParty': '第三方内容分发',
  'transactions.productTitle.OTT': 'OTT应用',
  'transactions.productTitle.MetaXSSP': 'MetaX程序化交易平台',

  'transactions.selectProducts': '选择产品',
  'transactions.confirmedRevenue': '确认收入',
  'transactions.currency': '币种',
  'transactions.exchangeRate': '汇率',
  'transactions.paymentRevenue': '已付金额',
  'transactions.financeCurrency': '财务币种',
  'transactions.financeExchangeRate': '财务汇率',
  'transactions.deduction': '核减金额',
  'transactions.deductionRemark': '说明',
  'transactions.paymentStatus': '付款状态',
  'transactions.paid': '已付款',
  'transactions.pending': '待付款',
}
